/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { SegmentFormFragmentDoc } from '../../features/segment/components/SegmentForm/SegmentForm.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatRoomStatus =
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'ActionRequired'
  /** 面談済み・対応中 */
  | 'Appointed'
  /** 対応不要 */
  | 'Archived'
  /** 契約済み */
  | 'ContractConcluded'
  /** 保険契約済み */
  | 'ContractConcludedInsurance'
  /** 証券契約済み */
  | 'ContractConcludedSecurities'
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'GotComplaints'
  /** 後追い対応 */
  | 'Keeping'
  /** 失注 */
  | 'LostOrder'
  /** チャット対応中 */
  | 'Messaging'
  /** 未設定 */
  | 'NotDefined'
  /** 面談設定中 */
  | 'Offering'
  /** 初回面談実施待ち */
  | 'WaitingForFirstAppointment';

export type ConditionInput = {
  clickURLCondition?: SegmentConditionClickUrlConditionInput | null | undefined;
  enqueteAnsweredCondition?: SegmentConditionEnqueteAnsweredInput | null | undefined;
  inflowSourceCondition?: SegmentConditionInflowSourceInput | null | undefined;
  loginLinkCondition?: SegmentConditionLoginLinkInput | null | undefined;
  roomStatusCondition?: SegmentConditionRoomStatusInput | null | undefined;
  userVariableDefinitionCondition?: SegmentConditionUserVariableDefinitionInput | null | undefined;
};

export type LineRichMenuActionType =
  | 'LINK'
  | 'TEXT';

export type LineRichMenuErrorReason =
  /** 同一セグメントの公開リッチメニューがすでに存在する */
  | 'DUPLICATE_SEGMENT_PUBLISHED'
  /** 上記の理由以外においてエラー */
  | 'UNKNOWN';

export type LineRichMenuInput = {
  backgroundImageFileName: string;
  chatBarText: string;
  isDisplayDefault: boolean;
  label: string;
  segment?: SegmentInput | null | undefined;
  status: LineRichMenuStatus;
  targetType: TargetType;
  template: string;
  templateActions: Array<LineRichMenuTemplateActionInput | null | undefined>;
};

export type LineRichMenuStatus =
  | 'PUBLISHED'
  | 'UNPUBLISHED';

export type LineRichMenuTemplateActionInput = {
  actionType: LineRichMenuActionType;
  label?: string | null | undefined;
  panelName: string;
  text?: string | null | undefined;
  url?: string | null | undefined;
};

export type SegmentConditionClickUrlConditionInput = {
  not: boolean;
  url: string;
};

export type SegmentConditionEnqueteAnsweredInput = {
  enqueteGUID: string;
  not: boolean;
};

export type SegmentConditionInflowSourceInput = {
  inflowSourceDefinitionGUID: string;
  not: boolean;
};

export type SegmentConditionLoginLinkInput = {
  not: boolean;
};

export type SegmentConditionRoomStatusInput = {
  not: boolean;
  status: ChatRoomStatus;
};

export type SegmentConditionUserVariableDefinitionInput = {
  definitionGUID: string | number;
  not: boolean;
  values: Array<string | number>;
};

export type SegmentInput = {
  conditions: Array<ConditionInput>;
};

export type TargetType =
  | 'ALL_FRIENDS'
  | 'ALL_MATCHED_USERS'
  | 'SEGMENT';

export type UpdateLineRichMenuInput = {
  guid: string | number;
  lineRichMenu: LineRichMenuInput;
};

export type LineRichMenuEditPageContentQueryVariables = Exact<{ [key: string]: never; }>;


export type LineRichMenuEditPageContentQuery = { segmentConditionParameters: { enqueteAnsweredCondition: { enquetes: Array<{ guid: string, title: string }> }, inflowSourceCondition: { inflowSources: Array<{ guid: string, inflowSourceName: string }> }, clickURLCondition: { clickUrls: Array<{ guid: string, url: string }> }, userVariableDefinitionCondition: { userVariableDefinitions: Array<{ guid: string, name: string, value:
          | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ guid: string, name: string }> }
          | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ guid: string, name: string }> }
          | Record<PropertyKey, never>
         }> } } };

export type LineRichMenuEditPageContentLineRichMenuPayloadFragment = { guid: string, label: string, status: Types.LineRichMenuStatus, templateName: string, backgroundImageFileName: string, chatBarText: string, isDisplayDefault: boolean, targetType: Types.TargetType, templateActions: Array<{ __typename: 'LineRichMenuTemplateAction', panelName: string, actionType: Types.LineRichMenuActionType, url: string | null, label: string | null, text: string | null }>, segment: { conditions: Array<
      | { __typename: 'SegmentConditionClickURLCondition', not: boolean, url: string }
      | { __typename: 'SegmentConditionEnqueteAnswered', enqueteGUID: string, not: boolean }
      | { __typename: 'SegmentConditionInflowSource', inflowSourceDefinitionGUID: string, not: boolean }
      | { __typename: 'SegmentConditionLoginLink', not: boolean }
      | { __typename: 'SegmentConditionRoomStatus', status: Types.ChatRoomStatus, not: boolean }
    > } | null };

export type UpdateLineRichMenuMutationVariables = Exact<{
  input: Types.UpdateLineRichMenuInput;
}>;


export type UpdateLineRichMenuMutation = { updateLineRichMenu:
    | { __typename: 'LineRichMenuErrorPayload', reason: Types.LineRichMenuErrorReason }
    | { __typename: 'UpdateLineRichMenuSuccessPayload', lineRichMenu: { guid: string, label: string, status: Types.LineRichMenuStatus, templateName: string, backgroundImageFileName: string, chatBarText: string, isDisplayDefault: boolean, targetType: Types.TargetType, templateActions: Array<{ __typename: 'LineRichMenuTemplateAction', panelName: string, actionType: Types.LineRichMenuActionType, url: string | null, label: string | null, text: string | null }>, segment: { conditions: Array<
            | { __typename: 'SegmentConditionClickURLCondition', not: boolean, url: string }
            | { __typename: 'SegmentConditionEnqueteAnswered', enqueteGUID: string, not: boolean }
            | { __typename: 'SegmentConditionInflowSource', inflowSourceDefinitionGUID: string, not: boolean }
            | { __typename: 'SegmentConditionLoginLink', not: boolean }
            | { __typename: 'SegmentConditionRoomStatus', status: Types.ChatRoomStatus, not: boolean }
          > } | null } }
   };

export const LineRichMenuEditPageContentLineRichMenuPayloadFragmentDoc = gql`
    fragment LineRichMenuEditPageContentLineRichMenuPayload on LineRichMenu {
  guid
  label
  status
  templateName
  backgroundImageFileName
  templateActions {
    __typename
    panelName
    actionType
    url
    label
    text
  }
  chatBarText
  isDisplayDefault
  targetType
  segment {
    conditions {
      ... on SegmentConditionLoginLink {
        __typename
        not
      }
      ... on SegmentConditionInflowSource {
        __typename
        inflowSourceDefinitionGUID
        not
      }
      ... on SegmentConditionClickURLCondition {
        __typename
        not
        url
      }
      ... on SegmentConditionEnqueteAnswered {
        __typename
        enqueteGUID
        not
      }
      ... on SegmentConditionRoomStatus {
        __typename
        status
        not
      }
    }
  }
}
    `;
export const LineRichMenuEditPageContentDocument = gql`
    query LineRichMenuEditPageContent {
  ...SegmentForm
}
    ${SegmentFormFragmentDoc}`;

/**
 * __useLineRichMenuEditPageContentQuery__
 *
 * To run a query within a Vue component, call `useLineRichMenuEditPageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineRichMenuEditPageContentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLineRichMenuEditPageContentQuery();
 */
export function useLineRichMenuEditPageContentQuery(options: VueApolloComposable.UseQueryOptions<LineRichMenuEditPageContentQuery, LineRichMenuEditPageContentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineRichMenuEditPageContentQuery, LineRichMenuEditPageContentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineRichMenuEditPageContentQuery, LineRichMenuEditPageContentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LineRichMenuEditPageContentQuery, LineRichMenuEditPageContentQueryVariables>(LineRichMenuEditPageContentDocument, {}, options);
}
export function useLineRichMenuEditPageContentLazyQuery(options: VueApolloComposable.UseQueryOptions<LineRichMenuEditPageContentQuery, LineRichMenuEditPageContentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineRichMenuEditPageContentQuery, LineRichMenuEditPageContentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineRichMenuEditPageContentQuery, LineRichMenuEditPageContentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LineRichMenuEditPageContentQuery, LineRichMenuEditPageContentQueryVariables>(LineRichMenuEditPageContentDocument, {}, options);
}
export type LineRichMenuEditPageContentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LineRichMenuEditPageContentQuery, LineRichMenuEditPageContentQueryVariables>;
export const UpdateLineRichMenuDocument = gql`
    mutation UpdateLineRichMenu($input: UpdateLineRichMenuInput!) {
  updateLineRichMenu(input: $input) {
    __typename
    ... on UpdateLineRichMenuSuccessPayload {
      lineRichMenu {
        ...LineRichMenuEditPageContentLineRichMenuPayload
      }
    }
    ... on LineRichMenuErrorPayload {
      reason
    }
  }
}
    ${LineRichMenuEditPageContentLineRichMenuPayloadFragmentDoc}`;

/**
 * __useUpdateLineRichMenuMutation__
 *
 * To run a mutation, you first call `useUpdateLineRichMenuMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLineRichMenuMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLineRichMenuMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLineRichMenuMutation(options: VueApolloComposable.UseMutationOptions<UpdateLineRichMenuMutation, UpdateLineRichMenuMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateLineRichMenuMutation, UpdateLineRichMenuMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateLineRichMenuMutation, UpdateLineRichMenuMutationVariables>(UpdateLineRichMenuDocument, options);
}
export type UpdateLineRichMenuMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateLineRichMenuMutation, UpdateLineRichMenuMutationVariables>;